<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>

    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md4>
          <v-select
            v-model="select_item_search"
            :items="items"
            item-text="name"
            item-value="id"
            label="أختر الصنف"
            persistent-hint
            return-object
            single-line
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-text-field
            type="number"
            v-model="serial_to_search"
            label=" ادخل السيريال"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="track_serials">تأكيد</v-btn>
        </v-flex>
        <br />
      </v-layout>
      <h4>الشراء</h4>
      <v-data-table
        :headers="headers"
        :items="importer_items"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ select_item_search.name }}</td>
          <td class="text-xs-right">{{ props.item.serial_from }}</td>
          <td class="text-xs-right">{{ props.item.serial_to }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">
            {{
              props.item.fatwora && props.item.fatwora.importer
                ? props.item.fatwora.importer.name
                : ""
            }}
          </td>
          <td class="text-xs-right">
            {{
              props.item.fatwora && props.item.fatwora.store
                ? props.item.fatwora.store.name
                : ""
            }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <h4>التحويلات</h4>
      <v-data-table
        :headers="headers2"
        :items="transfer_items"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ select_item_search.name }}</td>
          <td class="text-xs-right">{{ props.item.serial_from }}</td>
          <td class="text-xs-right">{{ props.item.serial_to }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">
            {{
              props.item.fatwora && props.item.fatwora.store_from
                ? props.item.fatwora.store_from.name
                : ""
            }}
          </td>
          <td class="text-xs-right">
            {{
              props.item.fatwora && props.item.fatwora.store_to
                ? props.item.fatwora.store_to.name
                : ""
            }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <h4>المبيعات</h4>
      <v-data-table
        :headers="headers3"
        :items="fatwora_items"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ select_item_search.name }}</td>
          <td class="text-xs-right">{{ props.item.serial_from }}</td>
          <td class="text-xs-right">{{ props.item.serial_to }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">
            {{
              props.item.fatwora && props.item.fatwora.store
                ? props.item.fatwora.store.name
                : ""
            }}
          </td>
          <td class="text-xs-right">
            {{
              props.item.fatwora && props.item.fatwora.client
                ? props.item.fatwora.client.name
                : ""
            }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import { items, track_serials } from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    appUrl: "",
    add_dialog: false,
    edit_dialog: false,
    modal1: false,
    modal2: false,
    modal3: false,
    date2: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    date3: "",
    headers: [
      { text: " اسم المنتج", value: "item.name", align: "right" },
      { text: " سيريال من ", value: "serial_from", align: "right" },
      { text: " سيريال الي ", value: "serial_from", align: "right" },
      { text: "  العدد", value: "count", align: "right" },
      { text: "المورد ", value: "serial_to", align: "right" },
      { text: "المخزن ", value: "serial_to", align: "right" },
      { text: " التاريخ", value: "created_at", align: "center" }
    ],
    headers2: [
      { text: " اسم المنتج", value: "item.name", align: "right" },
      { text: " سيريال ", value: "serial_from", align: "right" },
      { text: "من مخزن ", value: "serial_to", align: "right" },
      { text: "الي مخزن ", value: "serial_to", align: "right" },
      { text: "  العدد", value: "count", align: "right" },
      { text: "  من مخزن", value: "count", align: "right" },
      { text: "  الي مخزن", value: "count", align: "right" },
      { text: " التاريخ", value: "created_at", align: "center" }
    ],
    headers3: [
      { text: " اسم المنتج", value: "item.name", align: "right" },
      { text: " سيريال ", value: "serial_from", align: "right" },
      { text: "العميل", value: "serial_to", align: "right" },
      { text: "العدد", value: "count", align: "right" },
      { text: " التاريخ", value: "created_at", align: "center" }
    ],
    serial_to_search: "",
    select_item_search: { id: "" },
    select_item: { id: "" },
    select_item_edit: { id: "" },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    items: [],
    importer_items: [],
    transfer_items: [],
    fatwora_items: [],
    editedItem: {
      id: "",
      item_id: "",
      serial_from: "",
      serial_to: "",
      count: ""
    },
    newItem: {
      item_id: "",
      serial_from: "",
      serial_to: "",
      count: ""
    }
  }),
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    newItem_count() {
      let count =
        parseInt(this.newItem.serial_to) - parseInt(this.newItem.serial_from);
      return (this.newItem.count = count);
    },
    newItem_count_edit() {
      let count =
        parseInt(this.editedItem.serial_to) -
        parseInt(this.editedItem.serial_from);
      return (this.editedItem.count = count);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.appUrl = appUrl;
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));

    this.initialize();
  },

  methods: {
    initialize() {
      items().then(response => {
        this.items = response.data;
        this.loading = false;
      });
    },
    track_serials() {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("item_id", this.select_item_search.id);
      frmData.append("serial", this.serial_to_search);
      track_serials(frmData).then(response => {
        this.importer_items = response.data.importer_items;
        this.transfer_items = response.data.transfer_items;
        this.fatwora_items = response.data.fatwora_items;
        this.loading = false;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
